// Simple Gender Filter for Mobile Three-Level Navigation

// Single shared helper for mobile detection
function isMobileDevice() {
  return window.innerWidth <= 768 || document.body.classList.contains('mobile-view');
}
class GenderFilter {
    constructor() {
      const { storedGender, storedGenderIndex } = this.getStoredGenderData();
      this.currentGender = storedGender || null;
      this.currentGenderIndex = storedGenderIndex || null;
      this.pageContentLinksHandler = null;
      this.pageBackButtonHandler = null;
      this.mobileDrawer = document.querySelector('.mobile-navigation-drawer');
      
      this.init();
    }

    init() {
      this.bindEvents();
      // Only restore state on mobile devices
      if (isMobileDevice()) {
        this.restoreState();
      }
    }

    // Check if we have all required elements to function
    canInitialize() {
      return isMobileDevice() && this.mobileDrawer && this.mobileDrawer.querySelector('.gender-tab');
    }

    removeActiveClassFromElements(selector, activeClass) {
      const elements = this.mobileDrawer.querySelectorAll(selector);
      elements.forEach(element => element.classList.remove(activeClass));
    }

    setGenderData(gender, genderIndex) {
      this.currentGender = gender;
      this.currentGenderIndex = genderIndex;
      localStorage.setItem('selectedGender', gender);
      localStorage.setItem('selectedGenderIndex', genderIndex);
    }

    setGenderState(genderHandle, genderIndex) {
      this.setGenderData(genderHandle, genderIndex);
      
      // Activate the gender tab
      const genderTabs = this.mobileDrawer.querySelectorAll('.gender-tab');
      genderTabs.forEach(tab => tab.classList.remove('gender-tab--active'));
      
      const targetButton = this.mobileDrawer.querySelector(`[data-gender="${genderHandle}"].gender-tab`);
      if (targetButton) {
        targetButton.classList.add('gender-tab--active');
      }
      
      this.showGenderMenu(genderIndex);
      this.switchPromotionalImage(genderIndex);
    }

    getStoredGenderData() {
      return {
        storedGender: localStorage.getItem('selectedGender'),
        storedGenderIndex: localStorage.getItem('selectedGenderIndex')
      };
    }

    resetTierViews() {
      this.removeActiveClassFromElements('.tier-2-view', 'tier-2-view--active');
      this.removeActiveClassFromElements('.tier-3-view', 'tier-3-view--active');
    }

    activateElement(selector, dataAttribute, value) {
      const element = this.mobileDrawer.querySelector(`[${dataAttribute}="${value}"]${selector}`);
      if (element) {
        element.classList.add(selector.replace('.', '') + '--active');
      }
      return element;
    }
  
    bindEvents() {
      if (!this.mobileDrawer) { return; };

      this.mobileDrawer.addEventListener('click', (e) => {
        this.handleClickEvent(e);
      });
    }

    handleClickEvent(e) {
      if (e.target.classList.contains('gender-tab')) {
        e.preventDefault();
        this.handleGenderTabClick(e.target);
        return;
      }
      
      if (e.target.classList.contains('category-button')) {
        e.preventDefault();
        this.handleCategoryClick(e.target);
        return;
      }
      
      if (e.target.classList.contains('back-button')) {
        e.preventDefault();
        this.handleBackClick();
        return;
      }
    }
  
    handleGenderTabClick(button) {
      const genderHandle = button.getAttribute('data-gender');
      const genderIndex = button.getAttribute('data-gender-index');
      
      this.setGenderState(genderHandle, genderIndex);
    }
  
    switchPromotionalImage(genderIndex) {
      // Hide all promotional images
      this.removeActiveClassFromElements('.mobile-promo-image', 'mobile-promo-image--active');
  
      // Show the corresponding promotional image
      this.activateElement('.mobile-promo-image', 'data-gender-index', genderIndex);
    }
  
    showGenderMenu(genderIndex) {
      this.resetTierViews();
      this.activateElement('.tier-2-view', 'data-gender-index', genderIndex);
    }
  
    restoreState() {
      const { storedGender, storedGenderIndex } = this.getStoredGenderData();
      if (!storedGender || storedGenderIndex === null) {
        this.restoreDefaultState();
        return;
      }
      
      const targetButton = this.mobileDrawer.querySelector(`[data-gender="${storedGender}"].gender-tab`);
      if (!targetButton) {
        this.restoreDefaultState();
        return;
      }
      
      this.setGenderState(storedGender, storedGenderIndex);
    }

    restoreDefaultState() {
      const genderTabs = this.mobileDrawer.querySelectorAll('.gender-tab');
      const lastButton = genderTabs[genderTabs.length - 1];
      if (!lastButton) { return; };
      
      const defaultGender = lastButton.getAttribute('data-gender');
      const defaultGenderIndex = lastButton.getAttribute('data-gender-index');
      
      this.setGenderState(defaultGender, defaultGenderIndex);
    }

    handleCategoryClick(button) {
      const categoryHandle = button.getAttribute('data-category');

      this.resetTierViews();

      // Find tier-3 view matching both category AND current gender
      const tier3 = this.mobileDrawer.querySelector(
        `.tier-3-view[data-category="${categoryHandle}"][data-gender="${this.currentGender}"]`
      );
      if (tier3) {
        tier3.classList.add('tier-3-view--active');
      }
    }

    handleBackClick() {
      this.removeActiveClassFromElements('.tier-3-view', 'tier-3-view--active');

      if (this.currentGenderIndex === null) { return; };

      this.showGenderMenu(this.currentGenderIndex);
    }

    cleanup() {
      // Clear stored references
      this.currentGender = null;
      this.currentGenderIndex = null;
      
      // Clear localStorage cache
      localStorage.removeItem('selectedGender');
      localStorage.removeItem('selectedGenderIndex');
    }
  }
  
  let genderFilterInstance = null;

  function initGenderFilter() {
    if (!isMobileDevice()) { return false; };

    const mobileDrawer = document.querySelector('.mobile-navigation-drawer');
    if (!mobileDrawer) { return false; };
    
    const genderTabs = mobileDrawer.querySelectorAll('.gender-tab');
    if (!genderTabs || genderTabs.length === 0) { return false; };
    
    // Clean up existing instance if it exists
    if (genderFilterInstance) {
      genderFilterInstance.cleanup();
    }
    
    genderFilterInstance = new GenderFilter();
    return true;
  }
  // Expose initGenderFilter globally so main.js can call it
  window.initGenderFilter = initGenderFilter;

  // Check if mobile nav is already open on page load
  if (document.body.classList.contains('reveal-mobile-nav') && isMobileDevice()) {
    initGenderFilter();
  } 